import { useQuery } from "@tanstack/react-query";
import { keepPreviousData } from "@tanstack/react-query";
import { apiGet } from "./api";

export const useHealth = () =>
    useQuery({
        queryKey: ["health"],
        queryFn: () => apiGet("/health"),
        refetchInterval: 60_000,
        retry: 1,
    });

export const useCategories = () =>
    useQuery({
        queryKey: ["categories"],
        queryFn: () => apiGet("/categories"),
        staleTime: 120_000,
    });

export const useProducts = (params = {}) =>
    useQuery({
        queryKey: ["products", params],
        queryFn: () => apiGet("/products", params),
        placeholderData: keepPreviousData,
    });

export const useProduct = (slug) =>
    useQuery({
        queryKey: ["product", slug],
        queryFn: () => apiGet(`/products/${slug}`),
        enabled: !!slug,
        retry: 1,
    });
